import { type TypographyProps } from '@material-ui/system'

import { DiscoverBadgeStyled } from './styles/DiscoverBadgeStyled'
import { IconAddOn } from '@ui/elements/Icon/components'
import { getAnalyticsDataAttrs } from '@ui/utils/analytics'
import { type Enum } from '@ui/utils/enums'

export const DiscoverBadgeTypes = {
  ADD_ON: 'addOn',
  NEW: 'new',
} as const

export type DiscoverBadgeType = Enum<typeof DiscoverBadgeTypes>

export interface IDiscoverBadgeProps extends Pick<TypographyProps, 'fontSize'> {
  /**
   * Unique identifier for analytics tracking.
   */
  analyticsId?: string
  type: DiscoverBadgeType
  text: string
  size?: 'small' | 'medium'
  'aria-label'?: string
}

export const DiscoverBadge = ({
  analyticsId,
  type,
  text,
  size = 'medium',
  fontSize = 14,
  'aria-label': ariaLabel,
}: IDiscoverBadgeProps) => {
  const analyticsProps = getAnalyticsDataAttrs(analyticsId)

  return (
    <DiscoverBadgeStyled
      fontSize={fontSize}
      size={size}
      aria-label={ariaLabel}
      {...analyticsProps}
    >
      {type === DiscoverBadgeTypes.ADD_ON && (
        <IconAddOn size={10} block aria-hidden />
      )}
      <span>{text}</span>
    </DiscoverBadgeStyled>
  )
}

DiscoverBadge.displayName = 'DiscoverBadge'
